"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const redux_1 = require("redux");
const utils_1 = require("../utils");
const types = require("./types");
const typesSession = require("../session/types");
const errorMessage = utils_1.createErrorMessageReducer('workspaces');
const isProcessing = utils_1.createIsProcessingReducer('workspaces');
const workspaces = utils_1.createReducer(immutable_1.Map())({
    [typesSession.LOGIN_SUCCESS]: (state, action) => {
        const data = {};
        action.workspaces.forEach((workspace) => {
            data[workspace.id] = workspace;
        });
        return immutable_1.Map(data);
    },
    [types.CREATE_SUCCESS]: (state, action) => {
        return state.set(action.workspace.id, action.workspace);
    },
    [types.UPDATE_SUCCESS]: (state, action) => {
        return state.set(action.workspaceId, action.workspace);
    },
});
const activeWorkspaceId = utils_1.createReducer(null)({
    [typesSession.LOGIN_SUCCESS]: (state, action) => action.activeWorkspaceId,
    [types.CREATE_SUCCESS]: (state, action) => action.workspace.id,
    [types.SWITCH_ACTIVE]: (state, action) => action.workspaceId,
});
// tslint:disable-next-line: no-default-export
exports.default = redux_1.combineReducers({
    activeWorkspaceId, errorMessage, isProcessing, workspaces,
});
//# sourceMappingURL=reducers.js.map